import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import veterinarianDeleteAction from './veterinarianDelete.action.json' with { type: 'json' }
import { veterinarianObject } from '../veterinarianObject'

const veterinarianDeleteDefinition = defineAction({
  ...veterinarianDeleteAction,

  input: veterinarianObject.pick({
    id: true,
  }),
  output: veterinarianObject.pick({
    id: true,
    inactivatedAt: true,
  }),
})

export default veterinarianDeleteDefinition
